import React, { useState, useEffect } from "react";
import {
  CurrentStepSetAction,
  setSelectedPremiumServicesToStore,
  setSelectedPremiumServicesDsValetToStore,
} from "./../../../actions/action";
import chevronOrange from "../../../images/AC/ac_chevron_down_orange.png";
import CONSTANTS from "../../../constants";
import { connect } from "react-redux";
import OperationItemSummaryFlex from "./operationItemSummaryFlex";
import editIcon from "../../../images/AC/ac-edit-summary.png";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import { Link } from "react-router-dom";
import offerMobilityIcon from "../../../images/AC/ac-offer-mobility-blue.png";

const mapStateToProps = (state) => state;
const mapDispatchToProps = {
  CurrentStepSetAction,
  setSelectedPremiumServicesDsValetToStore,
  setSelectedPremiumServicesToStore,
};

const OperationsSummaryFlex = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  const { SelectedServices, personalInfos } = props.store;
  const [selectedPremiumServices, setSelectedPremiumServices] = useState(
    props.store.selectedPremiumServices || []
  );

  useEffect(() => {
    let selectedPsFiltred = [];
    selectedPremiumServices.forEach((prService) => {
      props.store.listPremiumServices.forEach((element) => {
        if (prService.idServicePremium === element.idServicePremium) {
          selectedPsFiltred = [...selectedPsFiltred, element];
        }
      });
    });
    setSelectedPremiumServices(selectedPsFiltred);
  }, []);

  return (
    <div className="rootPrestationsContainer">
      <div className="prestationSectionTitleContainer">
        <div className="prestationSectionTitle">
          {CONSTANTS.LABELS.needs_basket_title}
        </div>
        <img
          src={chevronOrange}
          className={isOpen ? "chevronDetail isOpen" : "chevronDetail"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>

      <div
        className={
          isOpen
            ? "prestationsContentContainer isOpen"
            : "prestationsContentContainer"
        }
      >
        <div className="interventionsTitle" tabIndex="0">
          {`${CONSTANTS.LABELS.summary_operation_operationlist_intervention} (${SelectedServices.length})`}
        </div>
        <div
          className="interventionsSubtitle"
          dangerouslySetInnerHTML={{
            __html: CONSTANTS.LABELS.summary_operation_operationlist_subtitle,
          }}
        ></div>
        {!!props.store.booking.happy && (
          <div
            className="happyHour"
            dangerouslySetInnerHTML={{
              __html: CONSTANTS.LABELS.email_happy_hour.replace(
                "{{>Basket.Reduction}}",
                props.store.booking.happy
              ),
            }}
          ></div>
        )}
        <div className="prestationsBodyContainer">
          <div className="separatorPrestations"></div>
          <div className="prestationsInfosContainer">
            {SelectedServices.map(function(forfait, fskey) {
              return (
                <OperationItemSummaryFlex
                  isForfait={forfait.forfaits && !!forfait.forfaits.length}
                  forfait={forfait}
                  key={fskey}
                />
              );
            })}
          </div>

          {((!!SelectedServices.length && !props.store.isEditMode) ||
            (!!SelectedServices.length &&
              props.store.isEditMode &&
              !props.expiredDate)) && (
            <Link
              to={CONSTANTS.SITE_ROUTS.SERVICESPAGE}
              onClick={(e) => {
                pushEventToGTM({
                  pageName: "summary",
                  eventAction: "Redirection::Internal::Modify",
                  eventLabel: "summary_modify_services",
                });
                props.CurrentStepSetAction(4);
              }}
            >
              <div className="editButton">
                <img src={editIcon} />
                <div className="editButtonTitle">
                  {CONSTANTS.LABELS.common_v2_modify}
                </div>
              </div>
            </Link>
          )}
        </div>

        {!!Object.values(selectedPremiumServices).length && (
          <div className="premiumServicesContainer">
            <div
              className="premiumServicesTitle"
              dangerouslySetInnerHTML={{
                __html: `${CONSTANTS.LABELS.summary_premium_options} (${
                  Object.values(selectedPremiumServices).length
                })`,
              }}
            ></div>

            <div className="separatorServices"></div>

            <div className="premiumServiceContent">
              {Object.values(selectedPremiumServices).map((service, skey) => {
                return (
                  <div className="premiumItem" key={skey}>
                    <img src={offerMobilityIcon} />
                    <div className="premiumItemTitle">{service.titre}</div>
                  </div>
                );
              })}
            </div>

            {(!props.store.isEditMode ||
              (props.store.isEditMode && !props.expiredDate)) && (
              <Link
                className="editServices"
                to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
                onClick={(e) => {
                  props.setSelectedPremiumServicesDsValetToStore([]);
                  const filtredServices = Object.values(
                    props.store.selectedPremiumServices
                  ).filter((item) => item.groupe !== "dsValet");
                  props.setSelectedPremiumServicesToStore(filtredServices);
                  pushEventToGTM({
                    pageName: "summary",
                    eventAction: "Redirection::Internal::Modify",
                    eventLabel: "summary_modify_services_premium",
                  });
                  props.CurrentStepSetAction(5);
                }}
              >
                <div className="editButton">
                  <img src={editIcon} />
                  <div className="editButtonTitle">
                    {CONSTANTS.LABELS.common_v2_modify}
                  </div>
                </div>
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OperationsSummaryFlex);
